import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReactionComponent} from './reaction.component';



@NgModule({
  declarations: [
    ReactionComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ReactionComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class ReactionModule { }
